import { render, staticRenderFns } from "./LoaderPayment.vue?vue&type=template&id=54553150&scoped=true&"
import script from "./LoaderPayment.vue?vue&type=script&lang=js&"
export * from "./LoaderPayment.vue?vue&type=script&lang=js&"
import style0 from "./LoaderPayment.vue?vue&type=style&index=0&id=54553150&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54553150",
  null
  
)

export default component.exports